/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { Error as PlatformError } from '../Platform';
import { PmcMessageType } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

/**
 * Code unique to REACH
 */
export interface ReachInterface {
    /**
     * Retrieve the Device ID used by Teamviewer to connect to the player.
     *
     * @throws {@link PlatformError}
     * if Teamviewer wasn't installed by REACH
     *
     * @throws {@link PlatformError}
     * if NamedValueCache is not implemented
     */
    getRemoteSupportDeviceId(): Promise<string>;
}

export function supportsReach(platform: unknown): platform is ReachInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PmcMessageType.RemoteSupportDeviceIdGet);
    }
    return platform instanceof Object && 'getRemoteSupportDeviceId' in platform;
}
